var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no_data"},[_c('v-icon',{staticClass:"no_data_icon"},[_vm._v("far fa-frown")]),_vm._v(" No Data Available ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }